import axios from 'axios'
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import {Spinner} from 'react-activity';
import {connect} from 'react-redux';
import Login from './components/login/Login';
// import './themes/DefaultTheme.css';
import BasePage from "./components/BasePage";
import {setIsLoggedIn, setLoginChecked} from "./actions/UserActions";
import RegisterPage from "./components/register/RegisterPage";
import {getUserByInvite, getUserByPasswordReset} from "./requests/UserRequests";
import RegistrationRequestPage from "./components/register/RegistrationRequestPage";
import ResetPasswordPage from "./components/reset-password-page/ResetPasswordPage";
import ResetPasswordFinishPage from "./components/reset-password-page/ResetPasswordFinishPage";
import RouterListener from "./components/RouterListener";
import {IntlProvider} from "react-intl";

//fontawesome
import {library as faLibrary} from '@fortawesome/fontawesome-svg-core'
import {faMoneyCheck, faCaretDown, faCaretUp, faCreditCard, faTrash, faEdit, faUser, faTimes} from '@fortawesome/free-solid-svg-icons'
import {getAppConfiguration} from "./requests/ConfigRequests";
import {setConfig} from "./reducers/AppReducer";
import DocumentTitle from "./DocumentTitle";
import AutoRegisterPage from "./components/register/auto-register/AutoRegisterPage";
import AutoRegisterConfirmInstructions from "./components/register/auto-register/AutoRegisterConfirmInstructions";
import AutoRegisterConfirm from "./components/register/auto-register/AutoRegisterConfirm";
import AutoRegisterAccounts from "./components/register/auto-register/AutoRegisterAccounts";
import AutoRegisterWaitingConfirmation from "./components/register/auto-register/AutoRegisterWaitingConfirmation";
import SystemError from "./components/SystemError";
import SiteErrorBoundary from "./error-boundaries/SiteErrorBoundary";

faLibrary.add(faMoneyCheck, faCaretDown, faCaretUp, faCreditCard, faTrash, faEdit, faUser, faTimes);




class App extends Component {

  constructor(props) {
    super(props);
    this.state = {messages: {}};
  }


  componentDidMount() {
    let configPromise = getAppConfiguration();
    let loginStatusPromise = axios.get("/api/login-status");
    Promise.all([configPromise, loginStatusPromise]).then((results) => {
      this.setState({
        messages: results[0].languages['en']
      });
      // Order matters here.
      if (results[1].data.status === "waiting-confirmation") {
        return;
      }
      this.props.setConfig(results[0]);
      this.props.setLoginChecked(true, results[1].data.isLoggedIn);
    });
  }

  render() {
    return (
      <SiteErrorBoundary>
        <IntlProvider locale="en" messages={this.state.messages}>
          <BrowserRouter>
            <div>
              <RouterListener/>
              <ToastContainer/>
              <Spinner animating={this.props.animating > 0} size={50} className="centered"/>
              {
                this.props.loginChecked &&
                <Switch>
                  <Route path={"/login"} component={Login}/>
                  <Route path="/register/:token" render={props =>
                    <RegisterPage invite={props.match.params.token} getUserByInvite={getUserByInvite}/>
                  }/>
                  <Route path="/system-error" render={props =>
                    <SystemError/>
                  }/>
                  <Route path="/registration-request" render={props =>
                    <RegistrationRequestPage/>
                  }/>
                  <Route path="/auto-register/create" render={props =>
                    <AutoRegisterPage/>
                  }/>
                  <Route path="/request-password-reset" render={props =>
                    <ResetPasswordPage/>
                  }/>
                  <Route path="/reset-password/:id" render={props =>
                    <ResetPasswordFinishPage getUserByPasswordReset={getUserByPasswordReset}
                                             passwordReset={props.match.params.id}/>
                  }/>
                  <Route path="/auto-register/confirm-instructions" render={props =>
                    <AutoRegisterConfirmInstructions/>
                  }/>
                  <Route path="/auto-register/confirm/:token" render={props =>
                    <AutoRegisterConfirm/>
                  }/>
                  <Route path="/auto-register/waiting-confirmation" render={props =>
                    <AutoRegisterWaitingConfirmation/>
                  }/>
                  <Route path="/auto-register/accounts" render={props =>
                    <AutoRegisterAccounts/>
                  }/>
                  <Route path="/" component={BasePage}/>
                </Switch>
              }
            </div>
          </BrowserRouter>
        </IntlProvider>
      </SiteErrorBoundary>
    );
  }
}

App.propTypes = {
  animating: PropTypes.number.isRequired,
};

export default connect(state => ({
  animating: state.default.animating,
  loginChecked: state.user.loginChecked,
}), {
  setIsLoggedIn,
  setLoginChecked,
  setConfig,
})(App);
